import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar, {
            flat: "",
            rounded: "xl",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn_primary, {
                rounded: "",
                onClick: _ctx.setToday,
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.viewMode === "day" ? " Retour " : "Aujourd'hui"), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_btn_prev, {
                onClick: _ctx.prev,
                size: "small"
              }, null, 8, ["onClick"]),
              _createVNode(_component_v_btn_next, {
                onClick: _ctx.next,
                size: "small"
              }, null, 8, ["onClick"]),
              (_ctx.calendar)
                ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.displayTodayMonth(_ctx.today)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn_toggle, {
                modelValue: _ctx.windowStep,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.windowStep) = $event)),
                rounded: "xl",
                onClick: _ctx.refreshTasks,
                class: "mb-1",
                mandatory: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_icon, {
                    value: "taskscalendarview",
                    icon: "$oss-calendar"
                  }),
                  _createVNode(_component_v_btn_icon, {
                    value: "taskslistview",
                    icon: "$fa-list"
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window, {
            modelValue: _ctx.windowStep,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.windowStep) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "taskscalendarview" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_sheet, {
                    style: {"border-radius":"16px"},
                    height: "800"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createBlock(_component_v_calendar, {
                                ref: "calendar",
                                modelValue: _ctx.focus,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.focus) = $event)),
                                events: _ctx.tasksCalendar,
                                "event-color": _ctx.getEventColor,
                                "view-mode": _ctx.viewMode,
                                key: _ctx.refreshKey,
                                "interval-count": "0",
                                "interval-height": 0,
                                "hide-header": "",
                                "onClick:event": _ctx.editTaskInCalendarView,
                                "onClick:more": _ctx.viewDay,
                                "onClick:date": _ctx.clickCalendarNewEvent
                              }, null, 8, ["modelValue", "events", "event-color", "view-mode", "onClick:event", "onClick:more", "onClick:date"]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "taskslistview" }, {
                default: _withCtx(() => [
                  (!_ctx.tasksDatabase && !_ctx.tasksDatabase.length)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                elevation: "0",
                                style: {"background-color":"#ffffff","border-radius":"25px"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                                      _createTextVNode(" Aucune tâches ce mois-ci ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_oss_data_table, {
                                headers: _ctx.tasksTableHeaders,
                                items: _ctx.taskList,
                                itemLength: _ctx.taskCount,
                                "show-select": false,
                                "x-dense": true,
                                striped: false,
                                "table-hover": true,
                                "fixed-footer": true,
                                "fixed-header": true,
                                "row-styles": _ctx.rowStyles,
                                "checkbox-color": "primary",
                                onClickRow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editTaskInListView($event)))
                              }, {
                                "item.id": _withCtx(({ item }) => [
                                  _createVNode(_component_v_menu, {
                                    absolute: "",
                                    "offset-y": ""
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                        class: "mx-1",
                                        color: "primary"
                                      }), null, 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, {
                                            onClick: _withModifiers(($event: any) => (_ctx.editTaskInListView(item)), ["stop"])
                                          }, {
                                            append: _withCtx(() => [
                                              (item.auto === true)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                      _createTextVNode("$oss-eye")
                                                    ])),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 1,
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                      _createTextVNode("$oss-edit")
                                                    ])),
                                                    _: 1
                                                  }))
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item.auto === true ? "Visualiser" : "Modifier"), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_v_list_item, {
                                            onClick: _withModifiers(($event: any) => (_ctx.deleteTask(item)), ["stop"])
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_btn_trash, { size: "small" })
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, null, {
                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                  _createTextVNode("Supprimer")
                                                ])),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                "item.owner": _withCtx(({ item }) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatUserTaskFrom(item.owner)), 1)
                                ]),
                                "item.members": _withCtx(({ item }) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatSelectedUsers(item.members)), 1)
                                ]),
                                "item.dueDate": _withCtx(({ item }) => [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTable(item.dueDate)), 1),
                                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.getDateFromNow(item) !== "" ? _ctx.getDateFromNow(item) : ""), 1)
                                ]),
                                "item.start": _withCtx(({ item }) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateTable(item.start)), 1)
                                ]),
                                "item.client": _withCtx(({ item }) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatCompany(item.client)), 1)
                                ]),
                                "item.type": _withCtx(({ item }) => [
                                  _createTextVNode(_toDisplayString(_ctx.formatType(item.type)), 1)
                                ]),
                                "item.status": _withCtx(({ item }) => [
                                  (_ctx.statusIcon(item.status))
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                        key: 0,
                                        location: "start"
                                      }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_icon, _mergeProps({
                                            color: _ctx.statusColor(item),
                                            onClick: _withModifiers(($event: any) => (_ctx.changeTaskStatus(item)), ["stop"]),
                                            size: "small"
                                          }, props), {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.statusIcon(item.status)), 1)
                                            ]),
                                            _: 2
                                          }, 1040, ["color", "onClick"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.statusText(item)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["headers", "items", "itemLength", "row-styles"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}